var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.loaded
    ? _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "940px",
            "content-class": "print-or-save-invoices-dialog",
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "print-or-save-dialog-container" },
            [
              _setup.hasValidatorErrors
                ? _c(_setup.checkList, {
                    tag: "component",
                    attrs: { model: _setup.model },
                  })
                : _c(_setup.steps[_setup.model.step], {
                    tag: "component",
                    attrs: { model: _setup.model },
                  }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }